/**
 * ⟦C60 · lot b · A-177⟧ **Le sommaire du Guide, moins les dossiers d'un système coupé.**
 *
 * Matt (03/10/2026) : le grand ménage retire le loyer, la boutique, les jalons, la bibliothèque, les
 * strikes, le bad buzz comme sanction et l'alignement. Un dossier qui n'explique que l'un d'eux sort du
 * sommaire (`content/meta.json → dossiers_par_systeme`) ; il reste écrit dans `content/guide.json`,
 * relisible, et revient en rallumant l'interrupteur. Tous les autres dossiers restent ENTIERS : « le
 * guide, lui, il peut être complet » (Matt, 02/10).
 *
 * Pur : aucun DOM, aucun store. Sans interrupteur coupé, la liste d'origine est rendue telle quelle
 * (même tableau, sans copie) : l'état neutre.
 */

import { retiresParLeMenage } from "@maxime/shared";

type PorteurDeMeta = Parameters<typeof retiresParLeMenage>[0];

export function dossiersDuSommaire<D extends { id: string }>(
  dossiers: readonly D[],
  content: PorteurDeMeta,
): readonly D[] {
  const retires = retiresParLeMenage(content, "dossiers_par_systeme");
  if (retires.size === 0) return dossiers;
  return dossiers.filter((d) => !retires.has(d.id));
}
